import { ELanguage } from "@microfrontends/react-components"
import { getCompanySuggestion } from "../../services/companyListService"

const DEFAULT_LIMIT_SUGGESTION_COUNT = 5

export const suggestCompany = async (keyword: string, langCode: ELanguage) => {
    if (keyword === '') {
        return
    }
    const suggestionCompanyResponse = await getCompanySuggestion(keyword, DEFAULT_LIMIT_SUGGESTION_COUNT, langCode)
    if (!suggestionCompanyResponse || !suggestionCompanyResponse.data || typeof suggestionCompanyResponse.data !== 'object') {
        return
    }
    const companySuggestionList = suggestionCompanyResponse.data.map((item) => {
        return {
            name: item?.attributes?.companyName ?? '',
            id: item?.attributes?.companyId ?? 0,
            isCCP: item?.attributes?.isCCP ?? 0,
            companySlug: item?.attributes.companySlug ?? ''
        }
    })
    return companySuggestionList.length > 0 ? companySuggestionList : null
}
